
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://llmezmvrefvqmyoijcjk.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxsbWV6bXZyZWZ2cW15b2lqY2prIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQxODU2MTAsImV4cCI6MjA0OTc2MTYxMH0.HzKeOJgMqgNsp35gWkbbaIeZBihxI8sMhd99Mf2CLdY'

export const supabase = createClient(supabaseUrl, supabaseKey);
